import {Settings} from '../constants/config';

type Params = Record<string, string | number | undefined | null> | null;

export const getApiRoute = (route: string, params?: Params, query?: Params): string => {
  const settings = Settings.getSettings();
  let path = route;

  if (params) {
    path = Object.keys(params).reduce((routeTemplate, key) => {
      const value = params[key];

      if (typeof value === 'undefined' || value === null) {
        return routeTemplate;
      } else {
        return routeTemplate.replace(`{${key}}`, value.toString());
      }
    }, route);
  }
  if (query) {
    const queryStr = Object.entries(query)
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .filter(([key, value]) => typeof value !== 'undefined' && value !== null)
      .map(([key, value]) => `${key}=${value}`)
      .join('&');

    path += '?';
    path += queryStr;
  }
  return `${settings.baseUrl}${path}`;
};
